var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"wrap-chart",class:_vm.chartName})])}
var staticRenderFns = []

export { render, staticRenderFns }